(() => {
  const initialized = new WeakSet();

  function mount(root) {
    if (!root || initialized.has(root)) return;

    const track = root.querySelector('[data-campaign-track]');
    if (!track) return;

    let slides = Array.from(track.querySelectorAll('[data-campaign-slide]'));
    if (!slides.length) return;

    initialized.add(root);

    const getOrder = (slide) => {
      const value = Number(slide.dataset.sortOrder);
      return Number.isFinite(value) ? value : 999999;
    };

    slides
      .slice()
      .sort((a, b) => getOrder(a) - getOrder(b))
      .forEach((slide) => track.appendChild(slide));

    slides = Array.from(track.querySelectorAll('[data-campaign-slide]'));

    const dots = root.querySelector('[data-campaign-dots]');
    const prev = root.querySelector('[data-campaign-prev]');
    const next = root.querySelector('[data-campaign-next]');
    let activeIndex = 0;
    let raf = 0;
    let autoplayTimer = 0;
    const autoplayDelay = 5000;
    const motionPreference = window.matchMedia?.('(prefers-reduced-motion: reduce)');

    const normalizeIndex = (index) => ((index % slides.length) + slides.length) % slides.length;

    const scrollToIndex = (index) => {
      const normalized = normalizeIndex(index);
      const target = slides[normalized];
      if (!target) return;
      const firstOffset = slides[0].offsetLeft;
      track.scrollTo({ left: target.offsetLeft - firstOffset, behavior: motionPreference?.matches ? 'instant' : 'smooth' });
      activeIndex = normalized;
    };

    const stopAutoplay = () => {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      autoplayTimer = 0;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (motionPreference?.matches || document.hidden || slides.length < 2) return;
      autoplayTimer = window.setInterval(() => scrollToIndex(activeIndex + 1), autoplayDelay);
    };

    const restartAutoplay = () => {
      stopAutoplay();
      startAutoplay();
    };

    motionPreference?.addEventListener('change', startAutoplay);

    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(slides.length - 1, index));
      if (dots) {
        dots.querySelectorAll('button').forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
    };

    const updateActiveFromScroll = () => {
      const trackRect = track.getBoundingClientRect();
      const viewportCenter = trackRect.left + track.clientWidth / 2;
      let bestIndex = 0;
      let bestDistance = Infinity;

      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        const distance = Math.abs(center - viewportCenter);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      setActive(bestIndex);
    };

    if (slides.length < 2) {
      if (dots) dots.hidden = true;
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    if (dots) {
      dots.hidden = false;
      dots.replaceChildren();
      slides.forEach((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'prem-v06-campaign-carousel__dot';
        button.setAttribute('aria-label', `${index + 1}번 기획전 보기`);
        button.addEventListener('click', () => {
          scrollToIndex(index);
          restartAutoplay();
        });
        dots.appendChild(button);
      });
    }

    if (prev) prev.addEventListener('click', () => {
      scrollToIndex(activeIndex - 1);
      restartAutoplay();
    });
    if (next) next.addEventListener('click', () => {
      scrollToIndex(activeIndex + 1);
      restartAutoplay();
    });

    track.addEventListener('scroll', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateActiveFromScroll);
    }, { passive: true });

    root.addEventListener('pointerenter', stopAutoplay);
    root.addEventListener('pointerleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);
    track.addEventListener('touchstart', stopAutoplay, { passive: true });
    track.addEventListener('touchend', restartAutoplay, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    window.addEventListener('resize', updateActiveFromScroll, { passive: true });
    setActive(0);
    track.scrollLeft = 0;
    startAutoplay();
  }

  function init(scope = document) {
    if (scope.matches && scope.matches('[data-prem-campaign-carousel]')) mount(scope);
    scope.querySelectorAll?.('[data-prem-campaign-carousel]').forEach(mount);
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
